export enum SnippetType {
  NoType = '',
  Email = 'Email',
  Sms = 'SMS',
}
